/*
  Share cart.

  One delegated click handler, so the button works wherever it lands: the cart page,
  the cart drawer, or any section Shopify re-renders under it.

  The permalink is built in Liquid on render and refreshed here whenever the cart
  changes, because navigator.share has to be called straight off the click. Awaiting a
  fetch first loses the user gesture and Safari rejects the call.
*/
(function () {
  if (window.vmCartShare) {
    return;
  }

  var FLASH_MS = 2000;
  var REFRESH_DEBOUNCE_MS = 350;
  var refreshTimer = null;

  function buttons() {
    return document.querySelectorAll('[data-vm-cart-share]');
  }

  /*
    Desktop Chrome and Edge expose navigator.share but often have nothing to share to,
    and the call rejects with NotAllowedError after the click looks like it did nothing.
    Copying is the useful desktop behaviour anyway, so only touch devices get the sheet.
  */
  function useShareSheet() {
    if (!navigator.share) {
      return false;
    }
    if (typeof window.matchMedia !== 'function') {
      return true;
    }
    return window.matchMedia('(hover: none) and (pointer: coarse)').matches;
  }

  function flash(button, text) {
    var label = button.querySelector('.vm-cart-share__label') || button;
    if (button.getAttribute('data-vm-flashing') === 'true') {
      return;
    }
    var original = label.textContent;
    button.setAttribute('data-vm-flashing', 'true');
    button.classList.add('is-copied');
    label.textContent = text;
    setTimeout(function () {
      label.textContent = original;
      button.classList.remove('is-copied');
      button.removeAttribute('data-vm-flashing');
    }, FLASH_MS);
  }

  function legacyCopy(button, url) {
    var field = document.createElement('textarea');
    field.value = url;
    field.setAttribute('readonly', '');
    field.style.position = 'fixed';
    field.style.top = '-9999px';
    document.body.appendChild(field);
    field.select();
    var done = false;
    try {
      done = document.execCommand('copy');
    } catch (error) {
      done = false;
    }
    document.body.removeChild(field);
    if (done) {
      flash(button, button.getAttribute('data-copied-label') || 'Link copied');
    } else {
      window.prompt('Copy this cart link', url);
    }
  }

  function copy(button, url) {
    if (navigator.clipboard && window.isSecureContext) {
      navigator.clipboard
        .writeText(url)
        .then(function () {
          flash(button, button.getAttribute('data-copied-label') || 'Link copied');
        })
        .catch(function () {
          legacyCopy(button, url);
        });
      return;
    }
    legacyCopy(button, url);
  }

  /* Rebuild the item list from the live cart. The base and the query (which carries the
     discount code) come from what Liquid rendered, so a code stays attached. */
  function refresh() {
    var targets = buttons();
    if (!targets.length) {
      return;
    }

    fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart.js' : '/cart.js', {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin',
    })
      .then(function (response) {
        return response.ok ? response.json() : null;
      })
      .then(function (cart) {
        if (!cart || !cart.items) {
          return;
        }
        var pairs = cart.items
          .map(function (item) {
            return item.variant_id + ':' + item.quantity;
          })
          .join(',');

        buttons().forEach(function (button) {
          var base = button.getAttribute('data-share-base');
          var query = button.getAttribute('data-share-query') || '?storefront=true';
          if (!base || !pairs) {
            return;
          }
          button.setAttribute('data-share-url', base + pairs + query);
        });
      })
      .catch(function () {
        /* Keep whatever Liquid rendered. A stale link still beats no link. */
      });
  }

  function scheduleRefresh() {
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(refresh, REFRESH_DEBOUNCE_MS);
  }

  document.addEventListener('click', function (event) {
    var button = event.target && event.target.closest ? event.target.closest('[data-vm-cart-share]') : null;
    if (!button) {
      return;
    }
    event.preventDefault();

    var url = button.getAttribute('data-share-url');
    if (!url) {
      return;
    }

    if (useShareSheet()) {
      navigator
        .share({
          title: button.getAttribute('data-share-title') || document.title,
          text: button.getAttribute('data-share-text') || '',
          url: url,
        })
        .catch(function (error) {
          /* Closing the sheet is a decision, not a failure. Anything else means the
             sheet never opened, so fall through to the clipboard. */
          if (error && error.name === 'AbortError') {
            return;
          }
          copy(button, url);
        });
      return;
    }

    copy(button, url);
  });

  /* Cart changes replace the markup around the button rather than firing an event we can
     listen for, so watch the containers Shopify re-renders and re-read the cart after. */
  function observe() {
    if (typeof MutationObserver !== 'function') {
      return;
    }
    var observer = new MutationObserver(function (records) {
      for (var i = 0; i < records.length; i++) {
        if (records[i].addedNodes.length || records[i].removedNodes.length) {
          scheduleRefresh();
          return;
        }
      }
    });

    ['main-cart-items', 'main-cart-footer', 'CartDrawer'].forEach(function (id) {
      var node = document.getElementById(id);
      if (node) {
        observer.observe(node, { childList: true, subtree: true });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observe);
  } else {
    observe();
  }

  window.vmCartShare = { refresh: refresh, copy: copy };
})();
